import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const ComponentePorcentaje = ({ percentage, size = 100 }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let progressColor = '#4caf50'; 
    if (percentage < 60) {
      progressColor = '#f44336'; 
    } else if (percentage >= 60 && percentage < 80) {
      progressColor = '#ffeb3b'; 
    }

    // Inicializar el gráfico
    const chartInstance = echarts.init(chartRef.current);

    // Configuración del gráfico
    const option = {
      series: [
        {
          type: 'pie',
          radius: ['70%', '90%'], // Define el ancho del círculo
          avoidLabelOverlap: false,
          label: {
            show: false, // Oculta etiquetas del gráfico
          },
          emphasis: {
            disabled: true, // Desactiva énfasis y hover
          },
          silent: true, // Desactiva eventos de hover y clic
          data: [
            {
              value: percentage,
              name: 'Progreso',
              itemStyle: {
                color: progressColor, // Color dinámico del progreso
              },
            },
            {
              value: 100 - percentage,
              name: 'Restante',
              itemStyle: {
                color: '#e0e0e0', // Color de la parte restante
              },
            },
          ],
        },
      ],
      graphic: {
        type: 'text',
        left: 'center',
        top: 'center',
        style: {
          text: `${percentage}%`,
          fontSize: size / 5, 
          fontWeight: 'bold',
        //   fill: '#333',
        },
      },
    };

    chartInstance.setOption(option);

    return () => {
      chartInstance.dispose();
    };
  }, [percentage, size]);

  return (
    <div
      ref={chartRef}
      style={{
        width: size,
        height: size,
      }}
    ></div>
  );
};

export default ComponentePorcentaje;
